import { lazy, Suspense } from "react";
import styled from "styled-components";

import SideMenu from "../../../SideMenu/components/SideMenu";
import HomeComponent from "../../Home";
import QuestionBankComponent from "../../QuestionBank";
import CourseMainSection from "../../Courses/components/Course";
import Loader from "../../../Common/utilities/loader/loader";

const OtherCoursesComponent = lazy(() => import("../../OtherCourses"))
const Bookmarks = lazy(() => import("../../Bookmarks/index"))
const ReactAceEditor = lazy(() => import("../../CodePlayGround/components/codeEditor/AceEditor"))
const Home = lazy(() => import("../../Home/components/Home/MainHomePage"))
const MyLearningsComponent = lazy(() => import("../../MyLearnings"))


const MainLayout = ({path} : {path: string}) => {

  const lazyRender = (component: any) => {
    return (
      <Suspense fallback={<Loader />}>
        {component}
      </Suspense>
    )
  }

  const renderMainContent = () => {
    switch (path) {
      case "home":
        return (
          <MainLayoutContainer>
            <SideMenu />
            <MainContentContainer>
              {lazyRender(<Home />)}
            </MainContentContainer>
          </MainLayoutContainer>
        )
      case "my-learnings":
        return (
          <MainLayoutContainer>
            <SideMenu />
            <MainContentContainer>
              {lazyRender(<MyLearningsComponent />)}
            </MainContentContainer>
          </MainLayoutContainer>
        )
      case "all-courses":
        // return <OtherCoursesComponent />
        return (
          <MainLayoutContainer>
            <SideMenu />
            <MainContentContainer>
              {lazyRender(<OtherCoursesComponent />)}
            </MainContentContainer>
          </MainLayoutContainer>
        )
        case "course":
          return (
            lazyRender(<CourseMainSection />)
          )
      case "question-bank":
        return (
          <MainLayoutContainer>
            <SideMenu />
            <MainContentContainer>
            <QuestionBankComponent />
            </MainContentContainer>
          </MainLayoutContainer>
        )
      case "bookmarks":
        return (
          <MainLayoutContainer>
            <SideMenu />
            <MainContentContainer>
              <Suspense fallback={<Loader />}>
                <Bookmarks />
              </Suspense>
            </MainContentContainer>
          </MainLayoutContainer>
        )
      case "code-playground":
        return (
          lazyRender(<ReactAceEditor />)
        )
      case "my-portfolio":
        return (
          <MainLayoutContainer>
            <SideMenu />
            <MainContentContainer>
              <OtherCoursesComponent />
            </MainContentContainer>
          </MainLayoutContainer>
        )
      default:
        // return <HomeComponent />
        return (
          <MainLayoutContainer>
            <SideMenu />
            <MainContentContainer>
              {lazyRender(<HomeComponent />)}
            </MainContentContainer>
          </MainLayoutContainer>
        )
    }
  }

  return renderMainContent()
}

export default MainLayout;

// styled components
const MainLayoutContainer = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: #0F172A;

  @media screen and (max-width: 1023px) {
    display: flex;
    flex-direction: column-reverse;

  }
`

const MainContentContainer = styled.div`
  height: 100vh;
  width: calc(100vw - 256px);
  background-color: #f7f8f9;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  /* padding: 20px; */

  @media screen and (max-width: 1023px) {
    width: 100vw;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    height: calc(100vh - 100px);
  }
  
`
